/* eslint-disable */
/* tslint:disable */
import PropTypes from 'prop-types';
import React from 'react';
export const MobileMenuHamburgerIcon = ({size, ...props}) => (
  <svg viewBox="0 0 20 14" fill="currentColor" width={ size || "20" } height={ size || "14" } {...props}>
    <path d="M0 12H20V14H0zM0 6H20V8H0zM0 0H20V2H0z" fill="#040D23" fillRule="evenodd" />
  </svg>
);
MobileMenuHamburgerIcon.displayName = 'MobileMenuHamburgerIcon';
MobileMenuHamburgerIcon.propTypes = {
  size: PropTypes.string
}
/* tslint:enable */
/* eslint-enable */
